function toggleItemLoading(item: Element, loading: boolean) {
    const ogText = item.getAttribute('data-og-text')
    const text = ogText || item.textContent

    if (loading) {
        item.setAttribute('data-og-text', text)

        item.textContent = 'Loading...'
        item.setAttribute('disabled', 'true')
        return
    }

    item.textContent = ogText || text
    item.removeAttribute('disabled')
}

export { toggleItemLoading }
